<template lang="html">
    <div class="w-100 bg-3 footer">
        <location-card :brand="brand" v-if="this.$route.name != 'NotFound'"></location-card>
        <div class="w-100 mt-5 foot d-flex justify-content-center">
            <div v-if="this.$route.meta.requiresAuth" class="col-4 col-sm-2 exitSpace d-flex justify-content-start align-items-center align-content-center ps-3" @click="logout">
                <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 6.62219V17.245C22 18.3579 21.2857 19.4708 20.1633 19.8754L15.0612 21.7977C14.7551 21.8988 14.449 22 14.0408 22C13.5306 22 12.9184 21.7977 12.4082 21.4942C12.2041 21.2918 11.898 21.0895 11.7959 20.8871H7.91837C6.38776 20.8871 5.06122 19.6731 5.06122 18.0544V17.0427C5.06122 16.638 5.36735 16.2333 5.87755 16.2333C6.38776 16.2333 6.69388 16.5368 6.69388 17.0427V18.0544C6.69388 18.7626 7.30612 19.2684 7.91837 19.2684H11.2857V4.69997H7.91837C7.20408 4.69997 6.69388 5.20582 6.69388 5.91401V6.9257C6.69388 7.33038 6.38776 7.73506 5.87755 7.73506C5.36735 7.73506 5.06122 7.33038 5.06122 6.9257V5.91401C5.06122 4.39646 6.28572 3.08125 7.91837 3.08125H11.7959C12 2.87891 12.2041 2.67657 12.4082 2.47423C13.2245 1.96838 14.1429 1.86721 15.0612 2.17072L20.1633 4.09295C21.1837 4.39646 22 5.50933 22 6.62219Z" fill="#030D45"/>
                <path d="M4.85714 14.8169C4.65306 14.8169 4.44898 14.7158 4.34694 14.6146L2.30612 12.5912C2.20408 12.49 2.20408 12.3889 2.10204 12.3889C2.10204 12.2877 2 12.1865 2 12.0854C2 11.9842 2 11.883 2.10204 11.7819C2.10204 11.6807 2.20408 11.5795 2.30612 11.5795L4.34694 9.55612C4.65306 9.25261 5.16327 9.25261 5.46939 9.55612C5.77551 9.85963 5.77551 10.3655 5.46939 10.669L4.7551 11.3772H8.93878C9.34694 11.3772 9.7551 11.6807 9.7551 12.1865C9.7551 12.6924 9.34694 12.7936 8.93878 12.7936H4.65306L5.36735 13.5017C5.67347 13.8052 5.67347 14.3111 5.36735 14.6146C5.26531 14.7158 5.06122 14.8169 4.85714 14.8169Z" fill="#030D45"/>
                </svg>
                <span class="ms-2 text-3">Cerrar sesión</span>
            </div>

            <div v-else class="col-4 col-sm-2"></div>
            
            <div class="col-4 col-sm-8 d-flex justify-content-center">
                <img :src="brand.logoHeader" class="logo align-self-center">
            </div>
            
            <div class="col-4 col-sm-2 text-3 font-2 d-flex h-100 cl-1 align-items-center align-content-center justify-content-end pe-4 pt-1"><b cass="fw-bold">ONICO</b>&nbsp;HEALTH</div>
        </div>
    </div>
</template>
<script>
import LocationCard from "@/components/locationCard.vue";
export default {
    name:"footSpace",
    props:{
        brand:{},
    },
    components: {
		LocationCard,
	},
    data(){
        return{

        }
    },
    methods:{
        logout(){
            localStorage.removeItem('keyPassHub');
            this.$router.replace({ path: '/'});
        },
    }
}
</script>
<style lang="css">
    .footer{
        min-height: 100px;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
    .foot{
        border-top:1px solid var(--quinary);
        height: 100px;
    }
    .logo{
        height: 50px;
    }
    .exitSpace{
        cursor: pointer;
    }
    .exitSpace svg{
        width: 30px;
        height: 30px;
        pointer-events: none;
    }
    .exitSpace svg path{
        fill: var(--primary);
    }
    
    .exitSpace span{
        color: var(--primary);
        pointer-events: none;
    }
    .exitSpace:hover svg path{
        fill: var(--secondary);
    }
    .exitSpace:hover span{
        color: var(--secondary);
    }

    .exitSpace:active{
        transform: scale(0.8);
    }
</style>